import { AgreeType } from "logic/src/objects/session/types";
import { observer } from "mobx-react";
import { ReactComponent as Logo } from "logic/src/components/icons/logoWithName.svg";
import "./index.scss";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import slogan from "@/assets/images/slogan.png";
import { META_DATA } from "logic/src/constants";

import i18next from "@/i18n";

const Policy = () => {
  const { search } = useLocation();
  const searchParse = queryString.parse(search);
  const [agreeType, setAgreeType] = useState<AgreeType>(AgreeType.userPrivacy);
  const [userPrivacyAgree, setUserPrivacyAgree] = useState<string>(""); // 服务协议
  const [infoCollectAgree, setInfoCollectAgree] = useState<string>(""); // 信息政策

  const initPolicy = async () => {
    const currentLang = META_DATA.language;
    const curUserPrivacyAgree = (
      await import(
        `logic/src/locale/sensechat/agreement/${currentLang}/userPrivacyAgree.ts`
      )
    ).default;
    const curInfoCollectAgree = (
      await import(
        `logic/src/locale/sensechat/agreement/${currentLang}/infoCollectAgree.ts`
      )
    ).default;
    setUserPrivacyAgree(curUserPrivacyAgree);
    setInfoCollectAgree(curInfoCollectAgree);
  };

  useEffect(() => {
    if (searchParse && searchParse.id) {
      setAgreeType(
        searchParse.id === "2" ? AgreeType.infoCollect : AgreeType.userPrivacy,
      );
    }
  }, []);

  // useEffect(() => {
  //   i18next.changeLanguage(searchParse.lang as string);
  // }, []);

  useEffect(() => {
    initPolicy();
  }, []);

  return (
    <div className="policy-content">
      <div className="policy-pattern-top"></div>
      <div className="policy-pattern-bottom"></div>
      <Logo className="slang-logo" />
      {/* <img className="slang-logo" src={slangBranchEnZh} alt="" /> */}
      <div className="policy-body">
        <span
          dangerouslySetInnerHTML={{
            __html:
              agreeType === AgreeType.userPrivacy
                ? userPrivacyAgree
                : infoCollectAgree,
          }}
        />
      </div>
      <div className="policy-footer">
        <img className="slogan-icon" src={slogan}></img>
      </div>
    </div>
  );
};

export default observer(Policy);
